import { OrderLineData } from '../types/types';
import { apiResource } from '../../../common/services/apiClient';

export const orderLineApi = apiResource<OrderLineData>('order-lines');
